// extracted by mini-css-extract-plugin
export default {"title":"CssCode_title__JtsjV","code":"CssCode_code__0vx7Y","copyIcon":"CssCode_copyIcon__X0ZyA","codeSnippet":"CssCode_codeSnippet__A5i6x"};